"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var getBackgroundColor = function getBackgroundColor(theme, type) {
  switch (type) {
    case 'accent':
      return theme.color.accent;

    case 'default':
      return theme.color.grey4;

    default:
      return theme.color.accent;
  }
};

var getFontColor = function getFontColor(theme, type) {
  switch (type) {
    case 'accent':
      return theme.color.white;

    case 'default':
      return theme.color.black1;

    default:
      return theme.color.white;
  }
};

var root = function root(theme, type) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("min-height:60px;background-color:", getBackgroundColor(theme, type), ";color:", getFontColor(theme, type), ";@media (max-width:767px){background-color:transparent;}")
  );
};

var _default = {
  root: root
};
exports.default = _default;